import React, { FunctionComponent } from 'react';
import { Props } from './UWTableRows.types';
import styles from './UWTableRows.module.scss';

const UWTableRows: FunctionComponent<Props> = ({ rows }) => {
  const longestRow = Math.max(...rows.map((row) => row.cells.length));

  const colSpanCalculator = (rowLength: number) => {
    return (cellIndex: number) => {
      return cellIndex === rowLength - 1 && rowLength < longestRow ? longestRow - rowLength + 1 : 1;
    };
  };

  return (
    <>
      {rows.map((row, i) => {
        const rowLength = row.cells.length;
        const calculateColSpan = colSpanCalculator(rowLength);

        return (
          <tr key={`row-${i}`} className={`${styles.row} ${row.htmlClass ? styles[row.htmlClass] : ''}`} tabIndex={0}>
            {row.cells.map((cell, j) => {
              return (
                <td
                  colSpan={calculateColSpan(j)}
                  key={`cell-${j}`}
                  className={cell.htmlClass ? styles[cell.htmlClass] : ''}>
                  {cell.value}
                </td>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};

export default UWTableRows;
